/**
 * 时间控件-限制月份
 */
export const rangePickerOptions = {
  disabledDate(date) {
    if (date > new Date()) {
      return true
    }
    return false
  }
}
